export default __webpack_public_path__ + "static/media/curseofpain.16a6be12.png";